$(function () {

  // 送料
  subtotalFreeShipping();
  var target_shipping = document.querySelector('.js-cart-form-items');
  // カートが空のときは監視対象が存在しない。null を渡すと例外で以降の処理が全て止まる
  if (target_shipping) {
    var observer_shipping = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach(mutation => {
        subtotalFreeShipping()
      });
    });
    observer_shipping.observe(target_shipping, { attributes: true, childList: true, subtree: false });
  }

  // チェックボックスの有効化・無効化
  cartoption_checked();

  // カートに追加・削除
  $('.js-cartoption-btn').on('click', function(){
    var variant_id = $(this).data('variant-id');
    if($(this).hasClass('js-cartoption-addcart')){
      $(this).parent('.js-cartoption').addClass('is-disabled');
      $(this).addClass('js-cartoption-removecart');
      $(this).removeClass('js-cartoption-addcart');
      cartoption_addCart(variant_id);
    }else if($(this).hasClass('js-cartoption-removecart')){
      $(this).parent('.js-cartoption').addClass('is-disabled');
      $(this).addClass('js-cartoption-addcart');
      $(this).removeClass('js-cartoption-removecart');
      cartoption_removeCart(variant_id);
    }
  });

  // デフォルトのカート更新機能 (削除・数量変更)
  // 変更を検知して、オプション商品の有効化・無効化を実行
  var targetNode = document.querySelector('.js-cart-form-items');
  var observer = new MutationObserver((mutationsList, observer) => {
    mutationsList.forEach(mutation => {
      fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        hasItem = false;
        data.items.forEach(function(item){
          $('.js-cartoption > .js-cartoption-btn').each(function(i,e){
            if($(e).data('variant-id') == item.variant_id){
              hasItem = true;
            }
          });
        });
        if(!hasItem){
          $('.js-cartoption-btn').addClass('js-cartoption-addcart');
          $('.js-cartoption-btn').removeClass('js-cartoption-removecart');
          cartoption_checked();
        }
      });
    });
  });
  // 同上。カートが空のときは対象が無い
  if (targetNode) {
    observer.observe(targetNode, { attributes: true, childList: true, subtree: false });
  }

  // ギフトボックス：モーダル
  $('.js-giftboxmodal-open').on('click', function(){
    $('.js-giftboxmodal-wrap').fadeIn(100);
    $('body').addClass('is-giftboxmodal-open');
  });
  $('.js-giftboxmodal-close').on('click', function(){
    $('.js-giftboxmodal-wrap').css('display', 'none');
    $('body').removeClass('is-giftboxmodal-open');
  });

});

/* ========================================
 * 送料
 * ======================================== */
function subtotalFreeShipping(){
  message = $('.free-shipping-bar__message').html();
  if(message == '送料無料'){
    $('.js-cart-subtotal').addClass('is-freeshipping');
    $('.free-shipping-bar').addClass('is-hide');
  }else{
    $('.js-cart-subtotal').removeClass('is-freeshipping');
    $('.free-shipping-bar').removeClass('is-hide');
  }
}

/* ========================================
 * チェックボックスの有効化・無効化
 * (1つだけ選択可能に)
 * ======================================== */
function cartoption_checked(){
  var incart_count = 0;
  $('.js-cartoption').addClass('is-hide');
  $('.js-cartoption-btn').each(function(i,e){
    if($(e).hasClass('js-cartoption-removecart')){
      $(e).parent('.js-cartoption').removeClass('is-hide');
      incart_count ++;
    }
  });
  if(incart_count == 0){
    $('.js-cartoption').removeClass('is-hide');
  }
}

/* ========================================
 * カートに追加
 * ======================================== */
function cartoption_addCart(variant_id){
  var formData = {
    'items': [{
    'id': variant_id,
    'quantity': 1
    }]
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    return fetch('/cart.js');
  })
  .then(response => response.json())
  .then(data => {
    window.location.href = '/cart';
  })
  .catch(error => {
    console.error('エラー:', error);
  });
}

/* ========================================
 * カートから削除
 * ======================================== */
function cartoption_removeCart(variant_id){
  fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
    var position = 0;
    var optionitem_quantity = 0;
    var optionitem_position = 0;
    data.items.forEach(function(i){
      position++;
      if(i.variant_id == variant_id){
        optionitem_quantity = i.quantity;
        optionitem_position = position;
      }
    });
    if(optionitem_position != 0){
      var formData = {
        'line': optionitem_position,
        'quantity': 0
      };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('エラー:', error);
      });
    }
  });
}